import authReducer from "./authReducer";
import userReducer from "./userReducer";
import paymentsReducer from "./paymentsReducer";
import photosReducer from "./photosReducer";
import todosReducer from "./todosReducer";
import guestsReducer from "./guestsReducer";
import invitationReducer from "./invitationReducer";
import dataReducer from "./dataReducer";
import efratReducer from "./efratReducer";
import helpersReducer from "./helpersReducer";

export const reducers = {
  authReducer,
  userReducer,
  dataReducer,
  invitationReducer,
  guestsReducer,
  todosReducer,
  photosReducer,
  paymentsReducer,
  efratReducer,
  helpersReducer,
};
